<app-terms-and-conditions *ngIf="routeIsTermsAndConditions == '/termsandconditions' "></app-terms-and-conditions>

<app-notice-of-privacy *ngIf="routeIsTermsAndConditions == '/noticeofprivacy'"></app-notice-of-privacy>

<app-login *ngIf="!logged && routeIsTermsAndConditions == ''"></app-login>

<app-navbar *ngIf="logged && routeIsTermsAndConditions == '' "></app-navbar>